import React, { useEffect, useState } from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  EditButton,
  Filter,
  SearchInput,
  SimpleList,
  Button,
  useDataProvider,
} from 'react-admin';

import { useMediaQuery } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';

const OrderFilter = (props: any) => (
  <Filter {...props} variant="outlined">
    <SearchInput
      label="Order No"
      source="orderNo~like"
      alwaysOn
    />

    <SearchInput
      label="Design Code"
      source="designCode~like"
      alwaysOn
    />
  </Filter>
);


// ===============================
// Custom CSV Download
// ===============================
const downloadCSV = (
  data: any[],
  filename: string
) => {

  if (!data || data.length === 0) {
    console.log('No data to export');
    return;
  }

  const headers = Object.keys(data[0]);

  const csvContent = [
    headers.join(','),

    ...data.map(row =>
      headers
        .map(header => {

          const value = row[header];

          if (
            value === null ||
            value === undefined
          ) {
            return '""';
          }

          if (typeof value === 'string') {
            return `"${value.replace(/"/g, '""')}"`;
          }

          if (typeof value === 'number') {
            return value.toString();
          }

          if (value instanceof Date) {
            return `"${value.toISOString()}"`;
          }

          return `"${String(value).replace(/"/g, '""')}"`;

        })
        .join(',')
    )

  ].join('\n');


  const blob = new Blob(
    [csvContent],
    {
      type: 'text/csv;charset=utf-8'
    }
  );

  const url =
    window.URL.createObjectURL(blob);

  const a =
    document.createElement('a');

  a.href = url;

  a.download = filename;

  document.body.appendChild(a);

  a.click();

  window.URL.revokeObjectURL(url);

  document.body.removeChild(a);
};


// ========================================
// MOBILE ORDER ITEM
// ========================================

const MobileOrderItem = ({
  record,
  hasEdit,
  hasExport,
  handleExport,
}: any) => {

  const dataProvider = useDataProvider();

  const [customer, setCustomer] =
    useState<any>(null);


  useEffect(() => {

    let mounted = true;

    if (!record?.customerId) {

      setCustomer(null);

      return;
    }


    dataProvider
      .getOne('customers', {
        id: record.customerId,
      })

      .then((response: any) => {

        if (mounted) {

          setCustomer(
            response.data
          );

        }

      })

      .catch((error) => {

        console.error(
          'Customer fetch error:',
          error
        );

        if (mounted) {

          setCustomer(null);

        }

      });


    return () => {

      mounted = false;

    };

  }, [
    record?.customerId,
    dataProvider
  ]);


  return (

    <div
      style={{
        width: '100%',
        padding: '8px 0',
        boxSizing: 'border-box',
      }}
    >

      {/* ========================= */}
      {/* ROW 1 */}
      {/* ========================= */}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
        }}
      >

        {/* EDIT */}

        {hasEdit && (

          <EditButton
            record={record}
            basePath="/orders"
          />

        )}


        {/* EXPORT */}

        {hasExport && (

          <Button
            label=""
            onClick={(e) =>
              handleExport(record, e)
            }
          >

            <GetAppIcon />

          </Button>

        )}


        {/* ORDER NUMBER */}

        <span
          style={{
            fontWeight: 600,
            marginLeft: 8,
          }}
        >

          {record.orderNo || ''}

        </span>


        {/* DATE */}

        {/* <span
          style={{
            marginLeft: 'auto',
            fontSize: 12,
            color: '#666',
          }}
        >

          {record.orderDate
            ? new Date(
                record.orderDate
              ).toLocaleDateString()
            : ''}

        </span> */}
        <div style={{ marginLeft: 'auto', display: "flex" }}>
          {/* ========================= */}
          {/* CUSTOMER NAME */}
          {/* ========================= */}

          <div
            style={{
              marginTop: 4,
              fontWeight: 500,
              color: '#1976d2',
              fontSize: 14,
            }}
          >

            👤 {customer?.customerName || ''}

          </div>


          {/* ========================= */}
          {/* MOBILE NUMBER */}
          {/* ========================= */}

          <div
            style={{
              marginTop: 4,
              fontSize: 13,
              color: '#555',
            }}
          >

            📞 {customer?.mobileNo || ''}

          </div>
        </div>

      </div>




    </div>

  );

};


// ========================================
// ORDER LIST
// ========================================

export const OrderList = (props: any) => {

  const propsObj: any = {
    ...props
  };

  const isSmall =
    useMediaQuery(
      (theme: any) =>
        theme.breakpoints.down('sm')
    );


  const dataProvider =
    useDataProvider();


  // =====================================
  // EXPORT
  // =====================================

  // const handleExport = async (
  //   record: any,
  //   e?: React.MouseEvent
  // ) => {

  //   if (e) {

  //     e.stopPropagation();

  //     e.preventDefault();

  //   }


  //   console.log(
  //     'Export button clicked:',
  //     record
  //   );


  //   try {

  //     const response =
  //       await dataProvider.getOne(
  //         'orders',
  //         {
  //           id:
  //             `export/${record.id}`
  //         }
  //       );


  //     const orderData =
  //       response.data;


  //     const filename =
  //       `Order_${record.orderNo ||
  //       record.id
  //       }_${new Date()
  //         .toISOString()
  //         .split('T')[0]
  //       }.csv`;


  //     downloadCSV(
  //       orderData,
  //       filename
  //     );


  //   } catch (error) {

  //     console.error(
  //       'Export error:',
  //       error
  //     );

  //   }

  // };
const handleExport = async (
  record: any,
  e?: React.MouseEvent
) => {
  if (e) {
    e.stopPropagation();
    e.preventDefault();
  }

  try {
    // 1. Order export data
    const response = await dataProvider.getOne('orders', {
      id: `export/${record.id}`,
    });

    let orderData: any = response.data;

    // 2. Customer data fetch karo
    let customerData: any = {};

    if (record.customerId) {
      try {
        const customerResponse = await dataProvider.getOne(
          'customers',
          {
            id: record.customerId,
          }
        );

        customerData = customerResponse.data || {};
      } catch (customerError) {
        console.error(
          'Customer fetch error:',
          customerError
        );
      }
    }

    // 3. Agar API array return karti hai
    if (Array.isArray(orderData)) {
      orderData = orderData.map((item: any) => ({
        ...item,

        // Mobile Number
        mobileNo:
          customerData.mobileNo ||
          record.mobileNo ||
          '',
      }));
    } 
    
    // 4. Agar API single object return karti hai
    else {
      orderData = {
        ...orderData,

        mobileNo:
          customerData.mobileNo ||
          record.mobileNo ||
          '',
      };
    }

    const filename =
      `Order_${
        record.orderNo ||
        record.id
      }_${
        new Date()
          .toISOString()
          .split('T')[0]
      }.csv`;

    // 5. CSV download
    downloadCSV(
      Array.isArray(orderData)
        ? orderData
        : [orderData],
      filename
    );

  } catch (error) {
    console.error(
      'Export error:',
      error
    );
  }
};

  // =====================================
  // EXPORT BUTTON
  // =====================================

  const ExportButton = ({
    record
  }: any) => (

    <Button
      label="Export"
      onClick={(e) =>
        handleExport(
          record,
          e
        )
      }
      startIcon={
        <GetAppIcon />
      }
    />

  );


  // =====================================
  // PERMISSIONS
  // =====================================

  if (propsObj.permissions) {

    const resourcename =
      `/${props.resource}`;


    const myPermissions =
      propsObj.permissions.filter(
        (item: any) =>
          item.NavigateUrl
            .toLowerCase()
            .trim() ===
          resourcename
      );


    if (
      myPermissions.length > 0
    ) {

      const p =
        myPermissions[0];


      propsObj.hasList =
        p.View === 1;

      propsObj.hasShow =
        p.View === 1;

      propsObj.hasEdit =
        p.Edit === 1;

      propsObj.hasDelete =
        p.Delete === 1;

      propsObj.hasCreate =
        p.Create === 1;

      propsObj.hasExport =
        p.Export === 1;

    }

  }


  return (

    <React.Fragment>

      <List
        {...propsObj}
        exporter={false}
        bulkActionButtons={false}
        title="Orders"
        filters={
          <OrderFilter />
        }
        pagination={
          propsObj.hasList
            ? undefined
            : false
        }
      >


        {/* ================================= */}
        {/* MOBILE */}
        {/* ================================= */}

        {isSmall ? (

          <SimpleList

            primaryText={(
              record: any
            ) => (

              <MobileOrderItem

                record={record}

                hasEdit={
                  propsObj.hasEdit
                }

                hasExport={
                  propsObj.hasExport
                }

                handleExport={
                  handleExport
                }

              />

            )}

            linkType={
              propsObj.hasEdit
                ? 'edit'
                : false
            }

          />

        ) : (

          /* ================================= */
          /* DESKTOP */
          /* ================================= */

          <Datagrid
            rowClick={
              propsObj.hasEdit
                ? 'edit'
                : undefined
            }
            className="salesPackingGrid"
          >

            {propsObj.hasEdit && (
              <EditButton />
            )}

            {propsObj.hasExport && (
              <ExportButton />
            )}


            <TextField
              source="orderNo"
              label="Order No"
            />


            <DateField
              source="orderDate"
              label="Order Date"
              locales="fr-FR"
            />


            <ReferenceField
              source="designCode"
              reference="product-groups"
              label="Design Code"
              link={false}
            >

              <TextField
                source="designCode"
              />

            </ReferenceField>


            <ReferenceField
              source="customerId"
              reference="customers"
              label="Customer"
              link={false}
            >

              <TextField
                source="customerName"
              />

            </ReferenceField>


            <ReferenceField
              source="customerId"
              reference="customers"
              label="Mobile No"
              link={false}
            >

              <TextField
                source="mobileNo"
              />

            </ReferenceField>


            <DateField
              source="createdDate"
              label="Created Date"
              locales="fr-FR"
            />

          </Datagrid>

        )}

      </List>

    </React.Fragment>

  );

};